"use client";

import Link from "next/link";
import { Button } from "@/app/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "@/app/components/ui/sheet";
import { Menu } from "lucide-react";
import { ExtendedSession } from "@/lib/interface/ExtendedSession";
import { Role } from "@prisma/client";
import { cn } from "@/lib/utils";
import { navigationMenuTriggerStyle } from "../ui/navigation-menu";
import { Accordion } from "../ui/accordion";
import AuctionsTab from "./NavBarAuctionsTab";
import AuthStatusButton from "./AuthStatusButton";

export default function MobileNavSheet({ session }: { session: ExtendedSession | null }) {
  const navButtonStyle = session?.role === Role.ADMIN
    ? "bg-slate-900 text-white"
    : "bg-transparent text-gray-800";

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Open menu">
          <Menu className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-3/4 sm:max-w-xs p-6 pt-10">
        <div className="w-full max-w-none flex flex-col items-stretch space-y-2">
          <SheetClose asChild>
            <Link href={"/"} className={cn(navigationMenuTriggerStyle(), navButtonStyle, "w-full px-4 justify-start text-left translate-y-2")}>Home</Link>
          </SheetClose>
          {session ? (
            <Accordion type="multiple" defaultValue={["auctions", "account"]} className="w-full">
              <AuctionsTab navButtonStyle={cn(navButtonStyle, "justify-start text-left")} variant="accordion" closeOnItemClick />
              <AuthStatusButton session={session} navButtonStyle={cn(navButtonStyle, "justify-start text-left")} variant="accordion" closeOnItemClick />
            </Accordion>
          ) : (
            <>
              <Accordion type="multiple" defaultValue={["auctions"]} className="w-full">
                <AuctionsTab navButtonStyle={cn(navButtonStyle, "justify-start text-left")} variant="accordion" closeOnItemClick />
              </Accordion>
              <SheetClose asChild>
                <Link href={"/api/auth/signin"} className={cn(navigationMenuTriggerStyle(), navButtonStyle, "w-full px-4 justify-start text-left -translate-y-2")}>Log in</Link>
              </SheetClose>
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}


